import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID, signal, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, RouterLink, RouterOutlet } from '@angular/router';
import { MatAnchor, MatButtonModule } from "@angular/material/button";
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from "@angular/material/expansion";
import { DialogService } from '../../../../../shared/services/dialog.service';
import { MatDialogClose } from "@angular/material/dialog";
import { HapticsService } from '../../../../../shared/general/services/haptics.service';
import { GtmService } from '../../../../../core/services/gtm.service';
import { SeoService } from '../../../../../shared/services/seo.service';
import { environment } from '../../../../../../environments/environment';
import { AuthService } from '../../../../../core/services/auth.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-common-forms',
  imports: [
    CommonModule,
    MatCardModule,
    RouterOutlet,
    MatAnchor,
    MatIconModule,
    MatButtonModule,
    RouterLink,
    MatExpansionModule,
    MatDialogClose,
    MatTooltipModule
],
  templateUrl: './common-forms.html',
  styleUrl: './common-forms.scss',
})
export class CommonForms implements OnInit {
  private dialog = inject(DialogService);
  private gtm = inject(GtmService);
  private haptics = inject(HapticsService);
  private auth = inject(AuthService);
  private platformId = inject(PLATFORM_ID);
  private route = inject(ActivatedRoute);

  isBrowser = signal(false);
  seo = inject(SeoService);
  currentUser = this.auth.currentUser;

  constructor() {
    this.isBrowser.set(isPlatformBrowser(this.platformId));
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      document.body.scrollTop = 0;
      this.gtm.pageView({
        page_path: '/common-forms',
        page_title: 'Common Forms | Horizinns'
      });

      this.route.queryParams.subscribe(params => {
        const targetForm = params['form'];
        
        if (targetForm === 'listing') {
          this.openListingForm();
        } else if (targetForm === 'terms') {
          this.openTermsForm();
        } else if (targetForm === 'w9') {
          const role = this.currentUser()?.role;
          if (role === 'sales' || role === 'admin') {
            this.openW9Form();
          }
        }
      });
    }
    this.seo.updateMetaTags('Common Forms', 'Common forms for use on Horizinns.', undefined, `${environment.appUrl}/common-forms`);
  }

  async openListingForm() {
    this.haptics.click();
    if (isPlatformBrowser(this.platformId)) {
      const { ListingFormDialog } = await import('./../sales-consultant-listing-form/listing-form-dialog/listing-form-dialog');
      this.dialog.open(ListingFormDialog, {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        autoFocus: false,
        panelClass: 'sales-listing-dialog'
      });
    }
  }
  
  async openTermsForm() {
    this.haptics.click();
    if (isPlatformBrowser(this.platformId)) {
      const { TermsFormDialog } = await import('./../sales-terms-form/terms-form-dialog/terms-form-dialog');
      this.dialog.open(TermsFormDialog, {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        autoFocus: false,
        panelClass: 'sales-listing-dialog'
      });
    }
  }

  async openW9Form() {
    this.haptics.click();
    if (isPlatformBrowser(this.platformId)) { 
      const role = this.currentUser()?.role;
      if (role === 'sales' || role === 'admin') {
        const { SalesW9FormDialog } = await import('./../sales-w9-form/sales-w9-form-dialog/sales-w9-form-dialog');
        this.dialog.open(SalesW9FormDialog, {
          width: '100vw',
          height: '100vh',
          maxWidth: '100vw',
          maxHeight: '100vh',
          autoFocus: false,
          panelClass: 'sales-listing-dialog'
        });
      }
    }
  }
}
